import React from "react";
import {
  Button,
  Type,
  Dialog,
  Flex,
  Card,
} from "@ebscois/react-component-library";
import PropTypes from "prop-types";
import {
  CardContentStyled,
  UserInactivityText,
  ResumeButtonStyled,
} from "./_.styled";

const UserInactivityDialog = ({ isOpen, onClose, handleResumeTracking }) => {
  return (
    <Flex container data-testid="user-inactivity-dialog-container">
      <Dialog
        aria-label="Inactivity"
        isOpen={isOpen}
        maxWidth="md"
        onRequestClose={onClose}
        data-testid="user-inactivity-dialog-dialog"
      >
        <Card paddingTop="lg" paddingLeft="sm" paddingBottom="md">
          <UserInactivityText
            element="p"
            fontSize="lg"
            textTransform="uppercase"
            data-testid="user-inactivity-dialog-title"
          >
            Please Note
          </UserInactivityText>
          <UserInactivityText
            element="p"
            fontSize="md"
            data-testid="user-inactivity-dialog-text"
          >
            We have
            <Type element="strong"> stopped tracking time-based CME</Type> for
            this topic due to inactivity.
          </UserInactivityText>
          <CardContentStyled>
            <Button
              variant="primary"
              kind="outlined"
              onClick={onClose}
              data-testid="user-inactivity-okay-button"
            >
              Okay
            </Button>
            <ResumeButtonStyled
              variant="primary"
              onClick={handleResumeTracking}
              data-testid="user-inactivity-resume-button"
            >
              Resume CME tracking
            </ResumeButtonStyled>
          </CardContentStyled>
        </Card>
      </Dialog>
    </Flex>
  );
};

UserInactivityDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default UserInactivityDialog;
